import { defineComponent as l, openBlock as t, createBlock as n, unref as r, mergeProps as p, withCtx as i, createElementVNode as d } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ l({
  name: "IconShopFilled",
  __name: "IconShopFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const a = o;
    return (c, e) => (t(), n(r(m), p(a, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        d("path", {
          "fill-rule": "evenodd",
          d: "M3.25 11.192a1.25 1.25 0 0 1-.84-1.473L3.5 4.994A2.25 2.25 0 0 1 5.694 3.25h12.614A2.25 2.25 0 0 1 20.5 4.994l1.09 4.725a1.25 1.25 0 0 1-.84 1.473V18.5a2.25 2.25 0 0 1-2.25 2.25H15a1.25 1.25 0 0 1-1.25-1.25V16a1.75 1.75 0 1 0-3.5 0v3.5A1.25 1.25 0 0 1 9 20.75H5.5a2.25 2.25 0 0 1-2.25-2.25v-7.308M9.685 4.75 9.296 9.025l.833.357a4.75 4.75 0 0 0 3.742 0l.833-.357-.39-4.275h-4.63M7.79 9.016 8.179 4.75H5.693a.75.75 0 0 0-.73.581L3.942 9.75h1.73a2.75 2.75 0 0 0 1.23-.29L7.79 9.016m9.305.444L16.21 9.016 15.82 4.75h2.486a.75.75 0 0 1 .73.581l1.02 4.419h-1.73a2.75 2.75 0 0 1-1.23-.29",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
